import { render, staticRenderFns } from "./ObservationsTable.vue?vue&type=template&id=282ae426&scoped=true&"
import script from "./ObservationsTable.vue?vue&type=script&lang=ts&"
export * from "./ObservationsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ObservationsTable.vue?vue&type=style&index=0&id=282ae426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ae426",
  null
  
)

export default component.exports